import React, { useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import HttpService from '../../services/httpService';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import moment from 'moment'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Paper, Grid, Divider, Button, Box} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    submitButton: {
        backgroundColor: '#F47E46',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D', // Darker Orange on hover
        },
    },
}));

const ReminderReport = (props) => {
    const classes = useStyles();
    const [startDate, setStartDate] = useState(moment().subtract(1, 'months').format('YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
    const [reminderNotes, setReminderNotes] = useState([]);
    const [reminderCloseRemark, setReminderCloseRemark] = useState('')
    const [closeRemarkModal, setCloseRemarkModal] = useState(false);
    const [leadLogId, setLeadLogId] = useState('')

    useEffect(() => {
        getMonthReminder()
        // eslint-disable-next-line
    }, [])

    const getMonthReminder = async () => {
        props.setLoading(true)
        let obj = {
            dateBetween: [startDate, endDate],
            flag: false
        }
        try {
            const result = await HttpService.reminderLogs(obj)
            setReminderNotes(result.data);
        } catch (error) {
            console.error(error)
            setReminderNotes([])
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getReminderData = async () => {
        props.setLoading(true)
        let obj = {}
        if (startDate === endDate) {
            obj.equalDate = startDate;
            obj.flag = true
        } else {
            obj.dateBetween = [startDate, endDate];
            obj.flag = false
        }
        try {
            const result = await HttpService.reminderLogs(obj)
            setReminderNotes(result.data);
        } catch (error) {
            console.error(error)
            setReminderNotes([])
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const handleReminderCloseButton = async(e, leadId)=>{
        props.setLoading(true);
        try{
            let obj = {
                leadId: leadId,
                leadLogId: leadLogId,
                reminderCloseRemark: reminderCloseRemark
            }
          await HttpService.closeReminder(leadLogId, obj);
          getMonthReminder();
          props.setSnackInfo('Reminder Close','success');
        }
        catch(err){
            props.setSnackInfo("Something went wrong",'error');
        }
        setCloseRemarkModal(false);
        setReminderCloseRemark('');
        props.setLoading(false);
    }
    
    const handleClose = (data)=>{
        setCloseRemarkModal(true);
        setLeadLogId(data._id);
    }

    return (
        <div>
            <Paper style={{ padding: 10, marginBottom: 20 }}>
                <div style={{ fontSize: 18 }}><b>Reminder</b></div>
                <div style={{ display: 'flex', marginTop: 10, marginBottom: 20 }}>
                    <TextField
                        id="date"
                        name="startDate"
                        label="From Date"
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        className={classes.textField}
                    />
                    <TextField
                        id="date"
                        name="endDate"
                        label="To Date"
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        className={classes.textField}
                    />
                    <Button variant="contained" color="primary" style={{ alignSelf: "center", marginLeft: 20 }} onClick={getReminderData} className={classes.submitButton} >
                        Submit
                    </Button>
                </div>
            </Paper>
            {reminderNotes?.map((data, i) => (
                <Grid item lg={6} md={6} key={i} style={{ marginBottom: '10px' }}>
                        <Accordion defaultExpanded className="accordian">
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={classes.heading}>
                                    <LocalActivityIcon />
                                    <span className="titlename">Deal Activity</span>
                                    <span className="datedata">{moment(data?.createdAt).format('lll')}</span>
                                </Typography>
                            </AccordionSummary>
                            <Divider />
                            <AccordionDetails>
                            <Typography>
                            <strong>
                                Customer Name: {data?.leadId?.customerId?.name}{' '}
                                </strong>
                                <span style={{ color: 'blue' }}>
                                <Link
                                    to={`/project-logs/${data?.leadId?._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    textAlign: "center",
                                    }}
                                >
                                    {data?.leadId?.lead_no}
                                </Link>
                                </span>
                                <br />
                                <strong>Message:</strong> {data?.notes}
                                <br />
                                <hr />
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                <div>
                                    <strong><small>Created By:</small></strong> <small>{data?.createdBy?.name}</small>
                                </div>
                                <Button 
                                    variant="contained" 
                                    color="secondary" 
                                    size="small" 
                                    style={{marginTop: '5px'}}
                                    onClick={() => handleClose(data)}
                                 >
                                    Close
                                </Button>
                                </Box>
                            </Typography>
                           {data.s3Location[0] && <AttachmentIcon onClick={() => window.open(data.s3Location[0])} /> }
                          </AccordionDetails>
                            <Dialog open={closeRemarkModal} onClose={() => setCloseRemarkModal(false)}>
                                <DialogTitle>Enter Close Reminder Remarks</DialogTitle>
                                <DialogContent>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="remarks"
                                        label="Remarks"
                                        type="text"
                                        fullWidth
                                        style={{ width: 400 }}
                                        value={reminderCloseRemark}
                                        onChange={(e) => setReminderCloseRemark(e.target.value)}
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setCloseRemarkModal(false)} color="primary" variant="outlined">
                                        Cancel
                                    </Button>
                                    <Button onClick={() => handleReminderCloseButton(data._id, data.leadId._id)} color="secondary" variant="outlined">
                                        Submit
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Accordion >
                </Grid>
            ))}
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(ReminderReport)
